import { isFeatureEnabled, serverData, isFeatureNotEnabled } from '../utils'
import {
  PRIVACY_HOME,
  PRIVACY_MERCHANT_HOME_FROM_DAR,
} from '../constants/constants'

const isMerchantUser = serverData.isMerchantUser
const privacySettingsLink = isMerchantUser
  ? PRIVACY_MERCHANT_HOME_FROM_DAR
  : PRIVACY_HOME
const communicationLink = '/myaccount/privacy/data/notifications/redirect'
const securityLink = '/myaccount/privacy/data/security/redirect'
const privacyhubMainlinkImage = 'privacy-hub-main-link-image'

export const homeConfig = {
  mainLinks: [
    {
      icon: {
        src: `https://${serverData.cdnHostName}/privacyhub/boolean-illustration.svg`,
        alt: 'switch',
      },
      title: 'privacyhub.home.mainlink.title1',
      description: 'privacyhub.home.mainlink.desc1',
      link: 'privacyhub.home.mainlink.link1',
      href: privacySettingsLink,
      name: 'controlYourPrivacy',
      id: 'privacyhubHomeSettingsLink',
    },
    {
      icon: {
        src: `https://${serverData.cdnHostName}/privacyhub/email-illustration.svg`,
        alt: 'email',
      },
      title: 'privacyhub.home.mainlink.title2',
      description: 'privacyhub.home.mainlink.desc2',
      link: 'privacyhub.home.mainlink.link2',
      href: communicationLink,
      name: 'manageEmails&Notifications',
      id: 'privacyhubHomeCommunicationLink',
    },
    {
      icon: {
        src: `https://${serverData.cdnHostName}/privacyhub/checkmark-illustration.svg`,
        alt: 'accept',
      },
      title: 'privacyhub.home.mainlink.title3',
      description: 'privacyhub.home.mainlink.desc3',
      link: 'privacyhub.home.mainlink.link3',
      href: securityLink,
      name: 'helpKeepYourAccountSecure',
      id: 'privacyhubHomeSecurityLink',
    },
    {
      icon: {
        src: `https://${serverData.cdnHostName}/privacyhub/info-illustration.svg`,
        alt: 'information',
      },
      title: 'privacyhub.home.mainlink.title4',
      description: 'privacyhub.home.mainlink.desc4',
      link: 'privacyhub.home.mainlink.link4',
      modal: 'privacyRights',
      name: 'knowYourDataRights',
      id: 'privacyhubHomePrivacyRightsLink',
    },
  ],
  othersAndData: [
    {
      key: 'otherssee',
      title: 'privacyhub.home.otherssee.title',
      description: 'privacyhub.home.otherssee.desc',
      link: 'privacyhub.home.otherssee.link',
      href: '/myaccount/privacy/privacyhub/others',
      name: 'whatOtherPeopleSee',
      id: 'privacyHubHomeLearnMore',
    },
    {
      key: 'datausage',
      title: 'privacyhub.home.datausage.title',
      description: 'privacyhub.home.datausage.desc',
      link: 'privacyhub.home.datausage.link',
      href: '/myaccount/privacy/privacyhub/data',
      name: 'exampleOfHowWeUseYourData',
      id: 'privacyHubHomeMoreInfo',
    },
  ],
}

export const dataUsageConfig = [
  {
    key: 'payandpaid',
    enabled: true,
    content: {
      title: 'privacyhub.data.payandpaid.title',
      desc1: 'privacyhub.data.payandpaid.desc1',
      desc2: 'privacyhub.data.payandpaid.desc2',
      link: 'privacyhub.data.payandpaid.link',
      href: privacySettingsLink,
      name: 'payAndGetPaid',
      id: 'privacyhubDataSettingsLink',
    },
    image: {
      src: `https://${serverData.cdnHostName}/privacyhub/card-change-illustration.svg`,
      alt: 'switch-payments',
      classname: 'privacy-hub-data-payandpaid-image',
    },
  },
  {
    key: 'communicate',
    enabled: true,
    content: {
      title: 'privacyhub.data.communicate.title',
      desc1: 'privacyhub.data.communicate.desc1',
      desc2: 'privacyhub.data.communicate.desc2',
      link: 'privacyhub.data.communicate.link',
      href: communicationLink,
      name: 'communicateWithYou',
      id: 'privacyhubDatacommunicationLink',
    },
    image: {
      src: `https://${serverData.cdnHostName}/privacyhub/ads-illustration.svg`,
      alt: 'photo-id',
      classname: 'privacy-hub-data-communicate-image',
    },
  },
  {
    key: 'relavantoffers',
    enabled: isFeatureEnabled('enabledForRelavantOffers'),
    content: {
      title: 'privacyhub.data.offers.title',
      desc1: 'privacyhub.data.offers.desc1',
      desc2: 'privacyhub.data.offers.desc2',
      link: 'privacyhub.data.offers.link',
      href: privacySettingsLink,
      name: 'providePersonalisedOffers',
      id: 'privacyhubDataOffersLink',
    },
    // update image
    image: {
      src: `https://${serverData.cdnHostName}/privacyhub/${serverData.country}/${serverData.language}/deals-illustration.svg`,
      alt: 'deals',
      classname: 'privacy-hub-data-deals-image',
    },
  },
  {
    key: 'personalizedads',
    enabled: isFeatureEnabled('enabledForPersonalizedAds'),
    content: {
      title: 'privacyhub.data.personalizedads.title',
      desc1: 'privacyhub.data.personalizedads.desc1',
      desc2: 'privacyhub.data.personalizedads.desc2',
      link: 'privacyhub.data.personalizedads.link',
      href: privacySettingsLink,
      name: 'providePersonalisedAds',
      id: 'privacyhubDataAdsLink',
    },
    // update image
    image: {
      src: `https://${serverData.cdnHostName}/privacyhub/${serverData.country}/${serverData.language}/deals-illustration.svg`,
      alt: 'personalized-ads',
      classname: 'privacy-hub-data-personalizedads-image',
    },
  },
  {
    key: 'protectaccount',
    enabled: true,
    content: {
      title: 'privacyhub.data.protectaccount.title',
      desc1: 'privacyhub.data.protectaccount.desc1',
      desc2: 'privacyhub.data.protectaccount.desc2',
      link: 'privacyhub.data.protectaccount.link',
      href: securityLink,
      name: 'helpProtectYourAccount',
      id: 'privacuhubDataProtectAccountLink',
    },
    image: {
      src: `https://${serverData.cdnHostName}/privacyhub/verify-id-illustration.svg`,
      alt: 'protect',
      classname: 'privacy-hub-data-protectaccount-image',
    },
  },
  {
    key: 'privacystatement',
    enabled: true,
    content: {
      title: 'privacyhub.data.privacystatement.title',
      desc1: 'privacyhub.data.privacystatement.desc1',
      link: 'privacyhub.data.privacystatement.link',
      href: '/webapps/mpp/ua/privacy-full',
      name: 'privacyStatement',
      id: 'privacyhubDataStmtLink',
    },
    image: {
      src: `https://${serverData.cdnHostName}/privacyhub/Group 99245632.svg`,
      alt: 'privacy-statement',
      classname: 'privacy-hub-data-privacystatement-image',
    },
  },
]

export const privacyRightsConfig = [
  {
    key: 'haveaccount',
    title: 'privacyhub.privacyrights.haveaccount.title',
    body: [
      {
        id: 'privacyhub.privacyrights.haveaccount.body1',
      },
      {
        id: 'privacyhub.privacyrights.haveaccount.body2',
      },
    ],
    link: 'privacyhub.privacyrights.haveaccount.link',
    href: PRIVACY_HOME,
    name: 'gotAPayPalAccount',
  },
  {
    key: 'donthaveaccount',
    title: 'dsrLoggedout.hub.title2',
    body: [
      {
        id: 'dsrLoggedout.hub.p3',
      },
    ],
    link: 'dsrLoggedout.privacyrights.donthaveaccount.link',
    href: '/myaccount/privacy/common/pypl',
    name: 'donthaveaccount',
  },
]

export const otherPageConfig = {
  whenYouPayOrGetPaid: [
    {
      enabled: true,
      title: 'privacyhub.home.otherssee.sendToSomeOne.title',
      desc: 'privacyhub.home.otherssee.sendToSomeOne.desc',
      list1: 'privacyhub.home.otherssee.sendToSomeOne.list1',
      list2: 'privacyhub.home.otherssee.sendToSomeOne.list2',
      footer: 'privacyhub.home.otherssee.sendToSomeOne.list3',
      img: {
        src: `https://${serverData.cdnHostName}/privacyhub/${serverData.country}/${serverData.language}/lunch-illustration.svg`,
        alt: 'Send to someone',
        classname: 'privacy-hub-other-sendtosomeone-image',
      },
      id: 'sendToSomeOne',
    },
    {
      enabled: true,
      title: 'privacyhub.home.otherssee.getPaid.title',
      desc: 'privacyhub.home.otherssee.getPaid.desc',
      list1: 'privacyhub.home.otherssee.getPaid.list1',
      list2: 'privacyhub.home.otherssee.getPaid.list2',
      list3: 'privacyhub.home.otherssee.getPaid.list3',
      img: {
        src: `https://${serverData.cdnHostName}/privacyhub/${serverData.country}/${serverData.language}/settings-ui-illustration.svg`,
        alt: 'Get paid',
        classname: 'privacy-hub-other-getpaid-image',
      },
      link: {
        text: 'privacyhub.home.otherssee.getPaid.link',
        href: privacySettingsLink,
        name: 'manageYourProfilePrivacyAndContacts',
      },
      id: 'getPaid',
    },
    {
      enabled: true,
      title: 'privacyhub.home.otherssee.askSomeone.title',
      desc: 'privacyhub.home.otherssee.askSomeone.desc',
      list1: 'privacyhub.home.otherssee.askSomeone.list1',
      img: {
        src: `https://${serverData.cdnHostName}/privacyhub/${serverData.country}/${serverData.language}/pay-request-illustration.svg`,
        alt: 'Ask someone',
        classname: 'privacy-hub-other-asksomeone-image',
      },
      id: 'askSomeone',
    },
    {
      enabled: isFeatureEnabled('enabledForPayBills'),
      title: 'privacyhub.home.otherssee.payBills.title',
      desc: 'privacyhub.home.otherssee.payBills.desc',
      list1: 'privacyhub.home.otherssee.payBills.list1',
      list2: 'privacyhub.home.otherssee.payBills.list2',
      img: {
        src: `https://${serverData.cdnHostName}/privacyhub/${serverData.country}/${serverData.language}/bill-illustration.svg`,
        alt: 'Pay Bills',
        classname: 'privacy-hub-other-paybills-image',
      },
      id: 'payBills',
    },
    {
      enabled: true,
      title: 'privacyhub.home.otherssee.giveToCharity.title',
      desc: 'privacyhub.home.otherssee.giveToCharity.desc',
      list1: 'privacyhub.home.otherssee.giveToCharity.list1',
      list2: 'privacyhub.home.otherssee.giveToCharity.list2',
      list3: 'privacyhub.home.otherssee.giveToCharity.list3',
      img: {
        src: `https://${serverData.cdnHostName}/privacyhub/${serverData.country}/${serverData.language}/donation-illustration.svg`,
        alt: 'Give to charity',
        classname: 'privacy-hub-other-givetocharity-image',
      },
      id: 'giveToCharity',
    },
  ],
  whenYouShopData: [
    {
      enabled: true,
      title: 'privacyhub.home.otherssee.buyWithPaypal.title',
      desc: 'privacyhub.home.otherssee.buyWithPaypal.desc',
      list1: 'privacyhub.home.otherssee.buyWithPaypal.list1',
      list2: 'privacyhub.home.otherssee.buyWithPaypal.list2',
      list3: 'privacyhub.home.otherssee.buyWithPaypal.list3',
      phone: 'privacyhub.home.otherssee.buyWithPaypal.phone',
      img: {
        src: `https://${serverData.cdnHostName}/privacyhub/${serverData.country}/${serverData.language}/shop-illustration.svg`,
        alt: 'Buy with PayPal',
        classname: 'privacy-hub-other-buywithpaypal-image',
      },
      id: 'buyWithPaypal',
    },
  ],
  LinkBanksAndCardsData: [
    //Gobal
    {
      enabled: isFeatureNotEnabled('disabledAddBankCardsGlobal'),
      title: 'privacyhub.home.otherssee.addBanksCards.title',
      desc: 'privacyhub.home.otherssee.addBanksCards.desc',
      desc2: 'privacyhub.home.otherssee.addBanksCards.desc2',
      id: 'addBanksCards',
    },
    //Brazil
    {
      enabled: isFeatureEnabled('enabledAddBankCardsBrazil'),
      title: 'privacyhub.home.otherssee.addBanksCardsBR.title',
      desc: 'privacyhub.home.otherssee.addBanksCardsBR.desc',
      desc2: 'privacyhub.home.otherssee.addBanksCardsBR.desc2',
      id: 'addBanksCards',
    },
  ],
}

export const businessPageConfig = {
  fqs: [
    //Gobal
    {
      enabled: isFeatureNotEnabled('disabledDatacontrollerGlobal'),
      title: 'privacyhub.business.faq.datacontroller.title',
      desc1: 'privacyhub.buisiness.faq.desc1',
      desc2: 'privacyhub.buisiness.faq.desc2',
      desc3: 'privacyhub.buisiness.faq.desc3',
      id: 'privacyhubBusinessPageDataController',
    },
    //Brazil
    {
      enabled: isFeatureEnabled('enabledDatacontrollerBrazil'),
      title: 'privacyhub.business.faqBR.datacontroller.title',
      desc1: 'privacyhub.buisiness.faqBR.desc1',
      desc2: 'privacyhub.buisiness.faqBR.desc2',
      desc3: 'privacyhub.buisiness.faqBR.desc3',
      id: 'privacyhubBusinessPageDataController',
    },
    {
      enabled: true,
      title: 'privacyhub.business.faq.dataprotection.title',
      desc1: 'privacyhub.business.faq.dataprotection.desc1',
      id: 'privacyhubBusinessPageDdataProtection',
    },
    {
      enabled: true,
      title: 'privacyhub.business.faq.datareceive.title',
      desc1: 'privacyhub.business.faq.datareceive.desc1',
      desc2: 'privacyhub.business.faq.datareceive.desc2',
      desc3: 'privacyhub.business.faq.datareceive.desc3',
      id: 'privacyhubBusinessPageDataProtection',
    },
  ],
}
export const principlesConfig = {
  KeyTakeaways: [
    {
      img: {
        src: `https://${serverData.cdnHostName}/privacyhub/handshake-illustration.svg`,
        alt: 'ShakeImage',
        classname: privacyhubMainlinkImage,
      },

      title: 'privacyhub.principles.mainlink.title1',
      description: 'privacyhub.principles.mainlink.desc1',
      id: 'management',
    },
    {
      img: {
        src: `https://${serverData.cdnHostName}/privacyhub/magnifying-glass-illustration.svg`,
        alt: 'SearchImage',
        classname: privacyhubMainlinkImage,
      },
      title: 'privacyhub.principles.mainlink.title2',
      description: 'privacyhub.principles.mainlink.desc2',
      id: 'noticeAndTransparency',
    },
    {
      img: {
        src: `https://${serverData.cdnHostName}/privacyhub/pen-illustration.svg`,
        alt: 'PenImage',
        classname: privacyhubMainlinkImage,
      },
      title: 'privacyhub.principles.mainlink.title3',
      description: 'privacyhub.principles.mainlink.desc3',
      id: 'choiceAndConsent',
    },
    {
      img: {
        src: `https://${serverData.cdnHostName}/privacyhub/doucment-folder-illustration.svg`,
        alt: 'DocFolderImage',
        classname: privacyhubMainlinkImage,
      },

      title: 'privacyhub.principles.mainlink.title4',
      description: 'privacyhub.principles.mainlink.desc4',
      id: 'collection',
    },
    {
      img: {
        src: `https://${serverData.cdnHostName}/privacyhub/document-illustration.svg`,
        alt: 'DocImage',
        classname: privacyhubMainlinkImage,
      },
      title: 'privacyhub.principles.mainlink.title5',
      description: 'privacyhub.principles.mainlink.desc5',
      id: 'useAndDisposal',
    },
    {
      img: {
        src: `https://${serverData.cdnHostName}/privacyhub/share-arrow-illustration.svg`,
        alt: 'ShareImage',
        classname: privacyhubMainlinkImage,
      },
      title: 'privacyhub.principles.mainlink.title6',
      description: 'privacyhub.principles.mainlink.desc6',
      id: 'sharingAndTransfer',
    },
    {
      img: {
        src: `https://${serverData.cdnHostName}/privacyhub/letter-checkmark-illustration.svg`,
        alt: 'MarkImage',
        classname: privacyhubMainlinkImage,
      },
      title: 'privacyhub.principles.mainlink.title7',
      description: 'privacyhub.principles.mainlink.desc7',
      id: 'accessAndQuality',
    },
    {
      img: {
        src: `https://${serverData.cdnHostName}/privacyhub/shield-illustration.svg`,
        alt: 'ShieldImage',
        classname: privacyhubMainlinkImage,
      },
      title: 'privacyhub.principles.mainlink.title8',
      description: 'privacyhub.principles.mainlink.desc8',
      id: 'security',
    },
  ],
  horizantalCardsConfig: [
    {
      id: 'info_need',
      title: 'privacyhub.principles.card.desc1',
    },
    {
      id: 'info_usage',
      title: 'privacyhub.principles.card.desc2',
    },
    {
      id: 'info_access',
      title: 'privacyhub.principles.card.desc3',
    },
  ],
}
